export default {"src":"/_next/static/media/search-alt_svgrepo_small.com.5e49e5f1.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};